<template>
    <v-dialog
        transition="dialog-top-transition"
        fullscreen
        hide-overlay
        v-model="dialog"

    >
        <template v-slot:default="dialog">
            <v-card class="property-info">
                <v-toolbar
                    color="primary"
                    dark
                >{{ 'Property # ' + property.property_id + ' - ' + formTitle }}
                          <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                    dark
                    text
                    @click="dialog.value = false"
                    >
                   Close
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
                <v-img
                height="300"
                :src="`http://appapi.commercialpropertiesinc.net/storage/uploads/files/${property.image.file}`"
                ></v-img>
                <v-card-title>Owner: {{ property.owner }}</v-card-title>
                <v-card-text>
                    <v-list class="transparent d-flex flex-wrap pb-0">
                        <v-list-item
                        >
                            <v-list-item-title>Building Type</v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                {{ buildingType }}
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item
                        >
                            <v-list-item-title>SQFT</v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                {{ property.sqft }}
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item
                        >
                            <v-list-item-title>Acres</v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                {{ property.acres }}
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item
                        >
                            <v-list-item-title>Year Purchased</v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                {{ property.year_purchased }}
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item
                        >
                            <v-list-item-title>Year Built</v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                {{ property.year_built }}
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item
                        >
                            <v-list-item-title>Purchased Price</v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                {{ property.purchased_price | currency }}
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item
                        >
                            <v-list-item-title>Construction Type</v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                {{ constructionType }}
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-list-item
                        >
                            <v-list-item-title>Roof Type</v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                                {{ roofType }}
                            </v-list-item-subtitle>
                        </v-list-item>
                    </v-list>
                    <v-tabs
                    v-model="tab"
                    background-color="primary"
                    dark
                    center-active
                    show-arrows
                    fixed-tabs
                    >
                        <v-tab>Contacts</v-tab>
                        <v-tab>Lease Information</v-tab>
                        <v-tab>Notes/Comments</v-tab>
                        <v-tab>Images</v-tab>
                        <v-tab>Files</v-tab>
                        <v-tab>Tasks</v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item>
                            <Contacts :property="property.id" />
                        </v-tab-item>
                        <v-tab-item>
                            <Lease :property="property.id" />
                        </v-tab-item>
                        <v-tab-item>                
                            <Comment v-for="(comment, index) in form.comments" :key="index" :item="comment"/>
                            <v-divider></v-divider>
                            <v-card flat tile class="comment-form" color="accent">
                                <v-card-text>
                                    <v-form ref="commentform">
                                        <v-textarea
                                            outlined
                                            ref="comment"
                                            v-model="comment.comment"
                                            label="Comment"    
                                            hide-details
                                            auto-grow
                                            rows="1" 
                                            dark                       
                                        ></v-textarea>
                                    </v-form>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions class="admin-action">
                                    <v-spacer></v-spacer>
                                    <v-btn large min-width="100%" color="primary" tile elevation="0" @click="sendComment" :loading="loading">Submit</v-btn>
                                    <v-spacer></v-spacer>
                                </v-card-actions> 
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat tile color="accent">
                                <v-card-text>
                                    <file-pond
                                        name="filepond"
                                        ref="filepond"
                                        label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                                        v-bind:allow-multiple="true"
                                        accepted-file-types="image/*"
                                        :server="{
                                            url: 'http://appapi.commercialpropertiesinc.net/api/uploads/property?id='+property.id+'&type=image',
                                            process: {
                                                headers: {
                                                    'Authorization': `Bearer ${token}`
                                                }
                                            },
                                            revert: {
                                                headers: {
                                                    'Authorization': `Bearer ${token}`
                                                },
                                            }
                                        }"
                                        v-bind:files="files"
                                        v-on:init="handleFilePondInit"
                                        v-on:processfile="handleFilePondProcessfile"
                                        v-on:processfilerevert="handleFilePondRevertfile"/>
                                </v-card-text>
                            </v-card>
                            <v-card flat tile class="mx-auto overflow-hidden">
                                <v-data-table
                                :headers="headers"
                                :items="form.images"
                                class="elevation-0"
                                item-key="id"
                                :loading="loading"
                                >
                                    <template v-slot:item.actions="{ item }">
                                        <v-btn small depressed color="orange" tile @click="makeFeatured(item.id)" v-if="item.featured != true">      
                                            <v-icon
                                            color="white"
                                            small
                                            >
                                            mdi-star-circle-outline
                                            </v-icon>
                                        </v-btn>  
                                        <v-btn small depressed color="secondary" tile :href='`http://appapi.commercialpropertiesinc.net/storage/uploads/files/${item.file}`' target="_blank">      
                                            <v-icon
                                            color="white"
                                            small
                                            >
                                            mdi-eye
                                            </v-icon>
                                        </v-btn>  
                                        <v-btn small depressed color="primary" tile @click="deleteItem(item)">                  
                                            <v-icon
                                            small
                                            >
                                            mdi-delete
                                            </v-icon>  
                                        </v-btn>  
                                    </template>
                                    <template v-slot:item.file_name="props">
                                        <a :href="`http://appapi.commercialpropertiesinc.net/storage/uploads/files/${props.item.file}`" target="_blank">
                                            <v-img
                                                :src="`http://appapi.commercialpropertiesinc.net/storage/uploads/files/${props.item.file}`"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                                width="100"
                                                height="100"
                                            >
                                                <template v-slot:placeholder>
                                                    <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                    >
                                                        <v-progress-circular
                                                        indeterminate
                                                        color="grey lighten-5"
                                                        ></v-progress-circular>
                                                    </v-row>
                                                </template>
                                            </v-img>                                
                                        </a>
                                    </template>
                                    <template v-slot:item.user="props">
                                        {{ props.item.user.name }}
                                    </template>
                                </v-data-table>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card color="red">
                                        <v-card-title class="subtitle-2 justify-center white--text">Are you sure to delete this item?</v-card-title>
                                        <v-card-actions class="red darken-4">
                                        <v-spacer></v-spacer>
                                        <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">Yes</v-btn>
                                        <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
                                        <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat tile color="accent">
                                <v-card-text>
                                    <file-pond
                                        name="filepond"
                                        ref="filepond"
                                        label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                                        v-bind:allow-multiple="true"
                                        accepted-file-types="image/*,application/*"
                                        :server="{
                                            url: 'http://appapi.commercialpropertiesinc.net/api/uploads/property?id='+property.id+'&type=file',
                                            process: {
                                                headers: {
                                                    'Authorization': `Bearer ${token}`
                                                }
                                            },
                                            revert: {
                                                headers: {
                                                    'Authorization': `Bearer ${token}`
                                                },
                                            }
                                        }"
                                        v-bind:files="files"
                                        v-on:init="handleFilePondInit"
                                        v-on:processfile="handleFilePondProcessfile"
                                        v-on:processfilerevert="handleFilePondRevertfile"/>
                                </v-card-text>
                            </v-card>
                            <v-card flat tile class="mx-auto overflow-hidden">
                                <v-data-table
                                :headers="headers"
                                :items="form.files"
                                class="elevation-0"
                                item-key="id"
                                :loading="loading"
                                >
                                    <template v-slot:item.actions="{ item }">
                                        <v-btn small depressed color="secondary" tile :href='`http://appapi.commercialpropertiesinc.net/storage/uploads/files/${item.file}`' target="_blank">      
                                            <v-icon
                                            color="white"
                                            small
                                            >
                                            mdi-eye
                                            </v-icon>
                                        </v-btn>  
                                        <v-btn small depressed color="primary" tile @click="deleteItem(item)">                  
                                            <v-icon
                                            small
                                            >
                                            mdi-delete
                                            </v-icon>  
                                        </v-btn>  
                                    </template>
                                    <template v-slot:item.file_name="props">
                                        <a :href="`http://appapi.commercialpropertiesinc.net/storage/uploads/files/${props.item.file}`" target="_blank">{{ props.item.file_name }}</a>
                                    </template>
                                    <template v-slot:item.user="props">
                                        {{ props.item.user.name }}
                                    </template>
                                </v-data-table>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card color="red">
                                        <v-card-title class="subtitle-2 justify-center white--text">Are you sure to delete this item?</v-card-title>
                                        <v-card-actions class="red darken-4">
                                        <v-spacer></v-spacer>
                                        <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">Yes</v-btn>
                                        <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
                                        <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <Tasks :property="property.id" />
                        </v-tab-item>
                    </v-tabs-items>
                </v-card-text>
            </v-card>
        </template>
    </v-dialog>
</template>
<script>
    import axios from 'axios'
    import { mapGetters, mapActions } from 'vuex'
    import Comment from './Comment.vue'
    import Contacts from './Contacts.vue'
    import Lease from './Lease.vue'
    import Tasks from './Tasks.vue'
    import TokenService from '../services/storage.service'

    export default {
        props: ['dialog', 'property'],
        data: () => ({
            loading: false,
            phases: [],
            form: {
                property_id: '',
                owner: '',
                street_address: '',
                city: '',
                state: 'AL',
                zip: '',
                building_type: '',
                sqft: '',
                acres: '',
                year_purchased: '',
                purchased_price: '',
                construction_type: '',
                roof_type: '',
                year_built: '',
                status: '',
                capital_improvement: '',
                notes: '',
                county: '',
                user: [],
                comments: [],
                files: [],
                images: []
            },
            yesno: [
                { label: 'Yes', value: 1},
                { label: 'No', value: 0}
            ],
            voptions: {
                toolbar: true,
                url: 'data-source'
            },
            requiredValue: true,
            files: [],
            tab: null,
            comment: {
                comment: '',
            },
            token: '',
            headers: [
                { text: 'File', value: 'file_name', sortable: false },
                { text: 'Added By', value: 'user', sortable: false },
                { text: 'Created At', value: 'created_at', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false, align: 'center' },
            ],
            dialogDelete: false,
            editedItem: {
                id: '',
            },
            defaultItem: {
                id: '',
            }
        }),

        components: {
            Comment,
            Contacts,
            Lease,
            Tasks
        },

        computed: {
            ...mapGetters({
                building_types: 'data/building_types',
                construction_types: 'data/construction_types',
                roof_types: 'data/roof_types',
                statuses: 'data/statuses',
                states: 'data/states'
            }),
            buildingType() {
                let bt = this.building_types.filter( bti => {
                    return bti.value == this.property.building_type
                })

                if(bt.length) {
                    return bt[0].label
                } else {
                    return ''
                }
            },
            constructionType() {
                let ct = this.construction_types.filter( cti => {
                    return cti.value == this.property.construction_type
                })

                if(ct.length) {
                    return ct[0].label
                } else {
                    return ''
                }
            },
            roofType() {
                let rt = this.roof_types.filter( rti => {
                    return rti.value == this.property.roof_type
                })

                if(rt.length) {
                    return rt[0].label
                } else {
                    return ''
                }
            },
            formTitle () {
                return this.property.street_address + ' ' + this.property.city + ', ' + this.property.state + ' ' + this.property.zip
            },
        },

        watch: {
            dialog (val) {
                if(val == true) {
                    this.getProperty()
                }
                this.$emit('update-dialog', val)
            },
        },

        created () {
            this.token = TokenService.getToken()
        },

        methods: {
            ...mapActions({
                updateProperty: 'data/updateProperty',
                addComment: 'data/addPropertyComment'
            }),
            close() {
                this.$emit('update-dialog', false)
            },
            getProperty() {
                if(this.property.id) {
                    this.loading = true
                    axios.get('properties/' + this.property.id)
                        .then(response => {
                            this.loading = false
                            this.form = response.data
                            this.$nextTick()
                        })
                }
            },
            makeFeatured(id) {
                this.loading = true
                axios.post('uploads/featured', { id: id })
                    .then(() => {
                        this.loading = false
                        this.getProperty()
                        this.$nextTick()
                    })
            },
            async submit() {
                let valid1 = await this.$refs.observer1.validate()

                if(valid1) {
                    this.loading = true
                    this.$set(this.form, 'id', this.property.id)
                    this.updateProperty(this.form).then(() => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'green')
                        this.$store.commit('SET_SNACK', 'Successfully saved!')
                        this.$router.push({ path: '/properties' })
                    }).catch(() => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    })
                } else {
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                }
            },
            async sendComment() {
                this.loading = true
                this.addComment({
                    id: this.id, 
                    comment: this.comment.comment,
                }).then(response => {
                    this.loading = false
                    this.form.comments.push(response)
                    this.comment.comment = ''
                    this.comment.parent = null
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved')
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save your comment! Please try again.')
                })
            },
            handleFilePondProcessfile: function () {
                this.getProperty();
                this.$nextTick()
            },
            handleFilePondRevertfile: function () {
                this.getProperty();
                this.$nextTick()
            },
            deleteItem (item) {
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },
            deleteItemConfirm () {
                this.loading = true
                axios.delete('uploads/property_by_id?id=' + this.editedItem.id)
                    .then(() => {
                        this.closeDelete()
                        this.getProperty()
                        this.$nextTick()
                    })
            },
            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                })
            },
            goToTab(link) {
                this.tab = link

                if(this.$vuetify.breakpoint.name == 'xs' || this.$vuetify.breakpoint.name == 'sm') {
                    this.drawer = false
                }
            }
        },
    }
</script>